import { createActionsHook, createStore } from 'react-sweet-state';
const store = createStore({
  initialState: {
    editorContext: undefined
  },
  actions: {
    getEditorContext: () => ({
      getState
    }) => getState().editorContext,
    setEditorContext: editorContext => ({
      setState
    }) => {
      setState({
        editorContext
      });
    }
  }
});
export const useChatContextStoreActions = createActionsHook(store);